// ISO 3166-1 alpha-2 codes; names come from the browser so they follow the UI language.
const CODES =
  "AF AX AL DZ AS AD AO AI AG AR AM AW AU AT AZ BS BH BD BB BY BE BZ BJ BM BT BO BA BW BR VG BN BG BF BI KH CM CA CV KY CF TD CL CN CO KM CG CD CK CR CI HR CU CW CY CZ DK DJ DM DO EC EG SV GQ ER EE SZ ET FK FO FJ FI FR GF PF GA GM GE DE GH GI GR GL GD GP GU GT GG GN GW GY HT HN HK HU IS IN ID IR IQ IE IM IL IT JM JP JE JO KZ KE KI XK KW KG LA LV LB LS LR LY LI LT LU MO MG MW MY MV ML MT MH MQ MR MU YT MX FM MD MC MN ME MS MA MZ MM NA NR NP NL NC NZ NI NE NG NU KP MK NO OM PK PW PS PA PG PY PE PH PL PT PR QA RE RO RU RW WS SM ST SA SN RS SC SL SG SX SK SI SB SO ZA KR SS ES LK KN LC VC SD SR SE CH SY TW TJ TZ TH TL TG TO TT TN TR TM TC TV UG UA AE GB US UY UZ VU VA VE VN VI YE ZM ZW".split(
    " ",
  );

export function countryOptions(
  locale?: string,
): { code: string; name: string }[] {
  let names: Intl.DisplayNames | null = null;
  try {
    names = new Intl.DisplayNames(locale ? [locale] : undefined, {
      type: "region",
    });
  } catch {
    names = null;
  }
  return CODES.map((code) => ({ code, name: names?.of(code) ?? code })).sort(
    (a, b) => a.name.localeCompare(b.name),
  );
}

/** Best guess at the visitor's country from their time zone, for the default. */
export function guessCountry(): string {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (tz === "Asia/Yangon" || tz === "Asia/Rangoon") return "MM";
    if (tz === "Europe/London" || tz === "Europe/Belfast") return "GB";
    if (tz === "Europe/Dublin") return "IE";
    if (tz === "Asia/Bangkok") return "TH";
    if (tz === "Asia/Singapore") return "SG";
    if (tz.startsWith("Australia/")) return "AU";
  } catch {
    /* fall through */
  }
  return "GB";
}
